import { Card, Col, Row } from "react-bootstrap";
import { IFullLicenceDetails } from "../../../../api/LicenceDetails";
import EpaField2Rows from "../../../../leap-components/EpaField2Rows";
import {
  LicenceDetailsIcon,
  RssIcon,
} from "../../../../leap-components/icons/LeapIcons";
import { GetRssUrl } from "../../../../api/Config";

interface LicenceHeaderProps {
  licence: IFullLicenceDetails;
}

const LicenceHeader = ({ licence }: LicenceHeaderProps) => {
  const licenceHeaderTitle = licence.organisationname + " - " + licence.regno;

  return (
    <Card className="flex-fill w-100">
      <Card.Header></Card.Header>
      <Card.Body className="pt-0">
        <Row>
          <Col className="col-12 col-md-6">
            <table className="no-border" style={{ marginTop: "0.6rem" }}>
              <tbody>
                <tr>
                  <td>
                    <LicenceDetailsIcon />
                  </td>
                  <td>
                    <h2>{licenceHeaderTitle}</h2>
                  </td>
                </tr>
              </tbody>
            </table>
            <div className="d-md-none" style={{ height: "20px" }}></div>
          </Col>
          <Col className="col-6 col-md-3">
            <EpaField2Rows
              label={"Authorisation Type"}
              value={licence.licencetype}
            />
          </Col>
          <Col className="col-6 col-md-3">
            <EpaField2Rows
              label={"Authorisation Status"}
              value={licence.licencestatus}
            />
          </Col>
        </Row>
        <Row
          className="g-0 m-0 p-0 align-items-center"
          style={{ lineHeight: "1", minHeight: "auto" }}
        >
          <Col className="col-12 col-md-6 m-0 p-0"></Col>
          <Col className="col-6 col-md-3 m-0 p-0"></Col>
          <Col className="col-6 col-md-3 m-0 p-0">
            <div className="d-inline-flex align-items-center m-0 p-0">
              <a
                href={GetRssUrl(licence.regno)}
                target="_blank"
                rel="noopener noreferrer"
              >
                <RssIcon />
              </a>
              <a
                href="https://www.epa.ie/resources/rss/"
                target="_blank"
                rel="noopener noreferrer"
              >
                About Authorisation RSS Feed
              </a>
            </div>
          </Col>
        </Row>
      </Card.Body>
    </Card>
  );
};

export default LicenceHeader;
